import apis from './apis'
import { axiosPost } from './axiosHelper'

export const track_click = async (params) => {
  const { container, target, platform } = params
  const payload = {
    container: container,
    target: target,
    platform: platform,
  }
  const res = await axiosPost(apis.track_click(), payload).then((res) => {
    if (res?.success) {
      console.log(res, 'click')
    } else {
      console.log(res, 'click')
      console.log(payload, 'payload')
    }
    return res
  })
  return res
}
